import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const DEMO_EMAIL = "demo@nursly.co.uk";

export function PlatformFooter() {
  const { user } = useAuth();
  const isDemo = user?.email?.toLowerCase() === DEMO_EMAIL;

  return (
    <footer
      className="shrink-0 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 px-4 text-center"
      style={{
        background: "#EDE9E0",
        color: "#4A5E52",
        fontSize: 12,
        fontFamily: "'Outfit', sans-serif",
        minHeight: 36,
        padding: "6px 16px",
      }}
    >
      {isDemo && (
        <>
          <span
            aria-label="Demo account"
            style={{
              background: "#1B4332",
              color: "#F9F6F1",
              padding: "2px 8px",
              borderRadius: 999,
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: "0.02em",
            }}
          >
            Demo account
          </span>
          <span style={{ color: "#9CA3AF" }}>·</span>
        </>
      )}
      <span>Need help?</span>
      <span>Email us at</span>
      <a
        href="mailto:support@nursly.co.uk"
        className="underline-offset-2 hover:underline"
        style={{ color: "#1B4332" }}
      >
        support@nursly.co.uk
      </a>
      <span style={{ color: "#9CA3AF" }}>·</span>
      <Link to="/help" className="underline-offset-2 hover:underline" style={{ color: "#4A5E52" }}>
        Help
      </Link>
      <span style={{ color: "#9CA3AF" }}>·</span>
      <a href="/privacy" target="_blank" rel="noreferrer" className="underline-offset-2 hover:underline" style={{ color: "#4A5E52" }}>
        Privacy Policy
      </a>
      <span style={{ color: "#9CA3AF" }}>·</span>
      <a href="/terms" target="_blank" rel="noreferrer" className="underline-offset-2 hover:underline" style={{ color: "#4A5E52" }}>
        Terms
      </a>
      <span style={{ color: "#9CA3AF" }}>·</span>
      <a href="/security" target="_blank" rel="noreferrer" className="underline-offset-2 hover:underline" style={{ color: "#4A5E52" }}>
        🔒 Security
      </a>
      <span style={{ color: "#9CA3AF" }}>·</span>
      <span>© 2026 Nursly</span>
    </footer>
  );
}
